/**
 * Shared helpers for whether persisted comps analysis is non-empty (QMA pipeline, Generate Comps UX).
 *
 * @param {unknown} analysis
 * @returns {boolean}
 */
export function hasCompsAnalysisContent(analysis) {
  if (analysis == null) return false;
  if (typeof analysis === "string") return analysis.trim().length > 0;
  if (Array.isArray(analysis)) return analysis.length > 0;
  if (typeof analysis === "object") return Object.keys(analysis).length > 0;
  return Boolean(analysis);
}
